// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Header from 'components/Header/Header'
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'

class MainLayout extends React.Component {
	render() {
		const { fullPageIsLoading } = this.props

		return (
			<div className="site-wrap">
				{ ! fullPageIsLoading &&
					<Header />
				}

				<div className="main-wrap">
					{ fullPageIsLoading &&
						<div className="page-loading">
							<div className="loading-spinner"></div>
						</div>
					}

					{ ! fullPageIsLoading &&
						<main className="main">
							<ErrorBoundary>
								{ this.props.children }
							</ErrorBoundary>
						</main>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		fullPageIsLoading: state.site.fullPageIsLoading
	}
}

export default connect( mapStateToProps )( MainLayout )
